import React from "react";
import { skipToken } from "@reduxjs/toolkit/query/react";
import { useParams } from "react-router";
import { Card } from "@sscs/ui";
import useSearch from "../../../hooks/useSearch";
import { useGetIssueDetailsQuery } from "../../../services/insights.api";
import { Insight } from "../../../types";
import styles from "./details.module.scss";
import License from "./License";
import Malware from "./Malware";
import RemediationSteps from "./RemediationSteps";
import Secret from "./Secret";
import Vulnerability from "./Vulnerability";

type DetailsProps = {
  issue: Insight;
};

const Details = ({ issue }: DetailsProps): React.JSX.Element | null => {
  const { groupId } = useParams();
  const { filters, isSearchFetching } = useSearch();
  const { data } = useGetIssueDetailsQuery(
    groupId && !isSearchFetching
      ? {
          groupId,
          filters,
          id: issue.id,
          type: issue.issue_type,
        }
      : skipToken,
  );
  let details: React.ReactNode = null;

  if (issue.issue_type === "license") {
    details = <License issue={issue} />;
  } else if (issue.issue_type === "malware") {
    details = <Malware issue={issue} />;
  } else if (issue.issue_type === "secret") {
    details = <Secret issue={issue} issueDetails={data} />;
  } else if (issue.issue_type === "violation") {
    details = (
      <Card.Card>
        <Card.Title>Issue description</Card.Title>
        <Card.Content>
          <div>{issue.long_description}</div>
        </Card.Content>
      </Card.Card>
    );
  } else if (issue.issue_type === "vulnerability") {
    details = <Vulnerability issue={issue} issueDetails={data} />;
  }

  return (
    <div className={styles["details-container"]}>
      {details}
      <RemediationSteps steps={data?.next_steps} />
    </div>
  );
};

export default Details;
